import { Alert, Stack } from '@mui/material';

type ErrorAlertProps = {
  readonly text: string;
};

export const ErrorAlert = (props: ErrorAlertProps) => (
  <Stack justifyContent="center" alignContent="center" padding={2} height="100%">
    <Stack direction="row" justifyContent="center">
      <Alert data-testid="error-alert" variant="outlined" severity="error">
        {props.text}
      </Alert>
    </Stack>
  </Stack>
);

type FailedQueryProps = { readonly error: unknown; readonly query: string };

export const FailedQueryAlert = (props: FailedQueryProps) => {
  console.error(props.error);

  return <ErrorAlert text={`Fehler beim Laden von ${props.query}`} />;
};
